import { SET_REFUNDS_AND_DISCOUNTS } from './constants';
import valueReducer from '../../../common/reducers/valueReducer';

export default valueReducer([], SET_REFUNDS_AND_DISCOUNTS);
